export default Object.freeze({
	NONE: '',
	IN: 'fit-in',
	FULL_IN: 'full-fit-in',
	ADAPTIVE: 'adaptive-fit-in',
});
